export const SIGNUP = 'SIGNUP';
export const LOGIN = 'LOGIN';
export const FETCH_JOBS = 'FETCH_JOBS';
export const SELECT_JOB = 'SELECT_JOB';
export const APPLY_JOB = 'APPLY_JOB';
export const UPDATE_APPLICATION_DATA = 'UPDATE_APPLICATION_DATA';
